export const PAIS = 'pais';
export const PROVINCIA = 'provincia';
export const LOCALIDAD = 'localidad';
export const PROFESION = 'profesion';
export const CLUB = 'club';
